// extracted by mini-css-extract-plugin
export default {"container":"WithdrawCandicacySuccessModal_container__+QI9e","title":"WithdrawCandicacySuccessModal_title__5uJMY","svg":"WithdrawCandicacySuccessModal_svg__YGumM"};